import BadgerAccordion from 'badger-accordion';

export default {
  init() {
    // Creating a new instance of the accordion
    // const accordionDomNode = document.querySelector('.js-badger-accordion');
    // const accordion = new BadgerAccordion(accordionDomNode);

    const accordions = document.querySelectorAll('.js-badger-accordion');

    Array.from(accordions).forEach((accordion) => {
      const ba = new BadgerAccordion(accordion, {
        openHeadersOnLoad: [0],
        roles: {
          region: true,
        },
        openMultiplePanels: true,
      });

      // console.log(ba.getState([0]));
    });
  },
};
